import { ComposedTheme, createUseStyles } from '@glu/theming';
import { IPopoverProps } from './Popover';

type TStyleProps = Pick<IPopoverProps, 'zIndex'>;

interface ITitleInterface {
  textTransform?: string;
  backgroundColor?: string;
  borderRadius?: number | number[];
  margin: number | number[];
  padding: number | number[];
}

export default createUseStyles(
  ({
    popover: {
      border,
      borderRadius,
      boxShadow,
      content: {
        backgroundColor: { defaultBackgroundColor },
        color: { negativeColor },
        lineHeight,
      },
      fontSize,
      title,
    },
  }: ComposedTheme) => ({
    a11ybutton: {
      '&:focus': {
        fontSize: 10,
        height: 'auto',
        margin: [0, 5],
        padding: [2, 4],
        position: 'static',
        width: 'auto',
      },
      background: 'transparent',
      border: 0,
      borderRadius: 0,
      clip: 'rect(0, 0, 0, 0)',
      height: 1,
      margin: -1,
      overflow: 'hidden',
      padding: 0,
      position: 'absolute',

      width: 1,
    },
    arrow: {
      // needed to ensure this style is dynamic so the dynamic ones above can find it, dumb but
      // it is what it is
      //
      // Need to set height and width at max possible so it can calculate center correctly.
      // The other styles will override.
      height: 22,
      margin: 0,
      overflow: 'hidden',
      position: 'absolute',
      width: 22,
    },
    root: {
      '& $arrow::after': {
        background: defaultBackgroundColor,
        border,
        boxShadow,
        content: "''",
        height: 11,
        position: 'absolute',
        width: 11,
      },
      '&[data-popper-out-of-boundaries]': {
        display: 'none',
      },
      '&[data-popper-placement^="bottom"] $arrow': {
        '&::after': {
          transform: 'translateX(50%) translateY(50%) rotate(45deg)',
        },
        top: -11,
      },
      '&[data-popper-placement^="bottom"] $arrow, &[data-popper-placement^="top"] $arrow': {
        height: 11,
        width: 11 * 2,
      },
      '&[data-popper-placement^="left"] $arrow': {
        '&::after': {
          transform: 'translateX(-50%) translateY(50%) rotate(45deg)',
        },
        right: -11,
      },
      '&[data-popper-placement^="left"] $arrow, &[data-popper-placement^="right"] $arrow': {
        height: 11 * 2,
        width: 11,
      },
      '&[data-popper-placement^="right"] $arrow': {
        '&::after': {
          transform: 'translateX(50%) translateY(50%) rotate(45deg)',
        },
        left: -11,
      },
      '&[data-popper-placement^="top"] $arrow': {
        '&::after': {
          transform: 'translateX(50%) translateY(-50%) rotate(45deg)',
        },
        bottom: -11,
      },
      display: 'none',
      background: defaultBackgroundColor,
      border,
      borderRadius,
      boxShadow,
      fontSize,
      lineHeight,
      padding: 16,
      zIndex: ({ zIndex }: TStyleProps) => zIndex,
      '&[data-show]': {
        display: 'block',
      },
    },
    title: {
      color: negativeColor,
      fontSize,
      fontWeight: 700,
      marginBottom: 14,
      textDecoration: 'none solid rgb(51,51,51)',
      ...(title as ITitleInterface),
    },
  })
);
